function AppConfig(
  LoopBackResourceGreenbackProvider,
  LoopBackResourceAdvertisingProvider,
  ConfigEnvironmentProvider,
  $urlRouterProvider,
  $httpProvider,
  $sceDelegateProvider,
  $compileProvider) {
  'ngInject';

  LoopBackResourceGreenbackProvider.setAuthHeader('X-Access-Token');
  LoopBackResourceGreenbackProvider.setUrlBase(ConfigEnvironmentProvider.getApiUrl("greenback"));
  LoopBackResourceAdvertisingProvider.setUrlBase(ConfigEnvironmentProvider.getApiUrl("advertising"));

  $sceDelegateProvider.resourceUrlWhitelist([
    'self',
    'http://www.gogreenback.com/**'
  ]);

  let redirectCount = 0;

  $httpProvider.interceptors.push(($q, $state, LoopBackAuthGreenback) => {
    'ngInject';
    return {
      responseError: (rejection) => {
        console.error(rejection);
        if (rejection.status === 401 && LoopBackAuthGreenback.currentUserId) {
          //prevent infinite redirects
          if(redirectCount >= 1) {
            setTimeout(() => {
              redirectCount = 0;
            }, 5000);
            return;
          }
          redirectCount++;
          console.error("Should be redirected to logout");
          $state.go("logout");
          return $q.resolve(rejection);
        }
        else {
          return $q.reject(rejection);
        }
      }
    };
  });

  $urlRouterProvider.otherwise('/login');
  $compileProvider.debugInfoEnabled(false);
}

export default AppConfig;



// WEBPACK FOOTER //
// ./js/config/app.config.js